const BaseComponent = require('common/home/view');

class GXHome extends BaseComponent {}

module.exports = GXHome;
